export const OLD_COMPANY_NAME = "Rosemount Financial Solutions (IFA) Ltd";
export const NEW_COMPANY_NAME = "Rosemount Financial Solutions (IFA) Limited";

export const replaceRegulatoryCompanyName = (regulatoryText) =>
  String(regulatoryText || "").split(OLD_COMPANY_NAME).join(NEW_COMPANY_NAME);

export const getRegulatoryWordingStatus = (regulatoryText) => {
  const text = String(regulatoryText || "");

  if (text.includes(OLD_COMPANY_NAME)) return "needs-update";
  if (text.includes(NEW_COMPANY_NAME)) return "updated";
  return text.trim() ? "not-applicable" : "missing";
};
